/** A brief glow around the AI Assistant page's composer: "Maya is here". */
export const pingComposer = (input: HTMLTextAreaElement) => {
  const frame = input.closest<HTMLElement>("[data-composer-frame]") ?? input;
  if (!frame.animate) return;
  const primary =
    getComputedStyle(document.documentElement)
      .getPropertyValue("--color-primary")
      .trim() || "#6438ff";
  frame.animate(
    [
      { boxShadow: `0 0 0 0 color-mix(in oklab, ${primary} 55%, transparent)` },
      {
        boxShadow: `0 0 0 14px color-mix(in oklab, ${primary} 0%, transparent)`,
      },
    ],
    { duration: 900, easing: "ease-out" },
  );
};
